import { c as _c } from "react/compiler-runtime";
import { ViewTransition } from 'react';
import { Controls } from './controls';
import { Docs } from './docs';
import { Experiments } from './experiments';
import css from './flags.module.scss';
import type { DataFile, Flag } from './types';
import { parseFlags } from './utils';
interface Props {
  dataFile: DataFile;
}
export function Flags(t0) {
  const $ = _c(9);
  const {
    dataFile
  } = t0;
  let t1;
  if ($[0] !== dataFile) {
    t1 = Object.values(parseFlags(dataFile));
    $[0] = dataFile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const experiments = t1;
  let t2;
  let t3;
  if ($[2] !== experiments) {
    t2 = <Controls flags={experiments} />;
    t3 = <Experiments flags={experiments} />;
    $[2] = experiments;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Docs />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <ViewTransition name="container"><div className={css.wrapper}>{t2}{t3}{t4}</div></ViewTransition>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}